<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      @if (viewMode) {
        <span class="page-title"> Fota Batch Details </span>
      }
      @if (!viewMode) {
        <span class="page-title">Create New Device Fota Batch </span>
      }
    </div>
    <div class="button-group">
      <app-fota-info></app-fota-info>
    </div>
  </div>
  <form [formGroup]="deviceFotaForm" novalidate>
    <!-- Fota Batch Details Section -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">FOTA Batch Details</h6>
        @if (!viewMode) {
          <div class="component-actions">
            <button
              class="primary-button"
              (click)="downloadMyFile()"
              type="button"
            >
              Download Sample FOTA Template
              <mat-icon class="btn-icon">download</mat-icon>
            </button>
          </div>
        }
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <div class="form-section">
          <!-- Batch ID -->
          @if (filter === true) {
            <div class="form-group">
              <label for="batchId" class="form-label">Batch ID</label>
              <mat-form-field appearance="outline">
                <mat-label>Batch ID</mat-label>
                <input
                  matInput
                  readonly
                  formControlName="batchId"
                  placeholder="FOTA Batch Id"
                />
              </mat-form-field>
            </div>
          }
          <!-- Batch Name -->
          <div class="form-group">
            <label for="name" class="form-label">Batch Name</label>
            <mat-form-field appearance="outline">
              <mat-label>Batch Name</mat-label>
              <input
                [readonly]="viewMode"
                matInput
                formControlName="name"
                placeholder="Batch Name"
                [required]="!viewMode"
              />
              @if (
                deviceFotaForm.controls['name'].touched &&
                deviceFotaForm.controls['name'].errors?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    deviceFotaForm.controls['name'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Batch Description -->
          <div class="form-group">
            <label for="description" class="form-label"
              >Batch Description</label
            >
            <mat-form-field appearance="outline">
              <mat-label>Batch Description</mat-label>
              <input
                [readonly]="viewMode"
                matInput
                placeholder="Batch Description"
                formControlName="description"
                [required]="!viewMode"
              />
              @if (
                deviceFotaForm.controls['description'].touched &&
                deviceFotaForm.controls['description'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    deviceFotaForm.controls['description'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Batch Date -->
          @if (viewMode) {
            <div class="form-group">
              <label for="createdAt" class="form-label">Batch Date</label>
              <mat-form-field appearance="outline">
                <mat-label>Batch Date</mat-label>
                <input
                  matInput
                  readonly
                  placeholder="Batch Date"
                  formControlName="createdAt"
                />
                @if (
                  deviceFotaForm.controls['createdAt'].touched &&
                  deviceFotaForm.controls['createdAt'].errors?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          }
          <!-- Batch Type -->
          <div class="form-group">
            <label for="ais140" class="form-label">Batch Type</label>
            <mat-form-field appearance="outline">
              <mat-label>Batch Type</mat-label>
              <mat-select formControlName="ais140" [disabled]="viewMode">
                <mat-option [value]="false"> Regular FOTA </mat-option>
                <mat-option [value]="true"> AIS140 FOTA </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Is FOTA Mandatory -->
          <div class="form-group">
            <label for="isFotaMandatory" class="form-label"
              >Is FOTA Mandatory</label
            >
            <mat-form-field appearance="outline">
              <mat-label>Is FOTA Mandatory</mat-label>
              <mat-select
                formControlName="isFotaMandatory"
                [disabled]="viewMode"
              >
                <mat-option [value]="false"> No </mat-option>
                <mat-option [value]="true"> Yes </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Upload File -->
          @if (!viewMode) {
            <div class="form-group">
              <label for="fileName" class="form-label">Upload File</label>
              <mat-form-field
                class="file-upload-container"
                appearance="outline"
              >
                <mat-label>Upload File</mat-label>

                <!-- Display File Name or Placeholder -->
                <input
                  matInput
                  type="text"
                  formControlName="fileName"
                  readonly
                />

                <!-- Hidden File Input -->
                <input
                  type="file"
                  accept=".csv"
                  aria-label="File"
                  class="d-none"
                  (change)="onFileChange($event)"
                  #fileInput
                />

                <!-- Custom Upload Button -->
                <button
                  mat-button
                  class="upload-btn"
                  (click)="fileInput.click()"
                  type="button"
                >
                  <mat-icon>attach_file</mat-icon>
                </button>

                <!-- Error Message -->
                @if (
                  deviceFotaForm.controls['fileName'].touched &&
                  deviceFotaForm.controls['fileName'].errors?.required
                ) {
                  <mat-error> This field is Mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
      </div>
      @if (!viewMode && createFota) {
        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section -->
        <div class="component-footer">
          <div class="button-group">
            <button
              type="button"
              class="submit-button"
              [disabled]="!file"
              (click)="SubmitBatch()"
            >
              Create Batch <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
    @if (filter === true) {
      <!-- KPI Section -->
      <div class="kpi-section">
        <!-- Total Uploaded Devices -->
        <div
          class="kpi-card kpi-gradient-blue"
          (click)="changeKPISelected('All')"
          tabindex="0"
          (keydown.enter)="changeKPISelected('All')"
        >
          <div class="kpi-details">
            <span class="kpi-content"
              >Total Uploaded Devices
              <app-info-tooltip
                block
                heading="Total Uploaded Devices"
                [description]="kpiInfo.totalUploaded"
                (click)="$event.stopPropagation()"
              ></app-info-tooltip
            ></span>
            <span class="kpi-value">
              {{ (totalUploaded ? totalUploaded : 0) | indianNumber }}
            </span>
          </div>
          <div class="kpi-visual">
            <img
              src="../../assets/uploaded.png"
              alt="Total Uploaded Devices Image"
            />
          </div>
        </div>

        <!-- Total Pending Devices -->
        <div
          class="kpi-card kpi-gradient-yellow"
          (click)="changeKPISelected('Pending')"
          tabindex="0"
          (keydown.enter)="changeKPISelected('Pending')"
        >
          <div class="kpi-details">
            <span class="kpi-content"
              >Total Pending Devices
              <app-info-tooltip
                block
                heading="Total Pending Devices"
                [description]="kpiInfo.pending"
                (click)="$event.stopPropagation()"
              ></app-info-tooltip
            ></span>
            <span class="kpi-value">
              {{ (NonInitiated ? NonInitiated : 0) | indianNumber }}
            </span>
          </div>
          <div class="kpi-visual">
            <img
              src="../../assets/pending.png"
              alt="Total Pending Devices Image"
            />
          </div>
        </div>
        <!-- Total In-Progress Devices -->
        <div
          class="kpi-card kpi-gradient-purple"
          (click)="changeKPISelected('In-Progress')"
          tabindex="0"
          (keydown.enter)="changeKPISelected('In-Progress')"
        >
          <div class="kpi-details">
            <span class="kpi-content"
              >Total In-Progress Devices
              <app-info-tooltip
                block
                heading="Total In-Progress Devices"
                [description]="kpiInfo.inProgress"
                (click)="$event.stopPropagation()"
              ></app-info-tooltip
            ></span>
            <span class="kpi-value">
              {{ (totalInProgress ? totalInProgress : 0) | indianNumber }}
            </span>
          </div>
          <div class="kpi-visual">
            <img
              src="../../assets/initiated.png"
              alt="Total In-Progress Devices Image"
            />
          </div>
        </div>

        <!-- Total Aborted Devices -->
        <div
          class="kpi-card kpi-gradient-pink"
          (click)="changeKPISelected('Aborted')"
          tabindex="0"
          (keydown.enter)="changeKPISelected('Aborted')"
        >
          <div class="kpi-details">
            <span class="kpi-content"
              >Total Aborted Devices
              <app-info-tooltip
                block
                heading="Total Aborted Devices"
                [description]="kpiInfo.aborted"
                (click)="$event.stopPropagation()"
              ></app-info-tooltip
            ></span>
            <span class="kpi-value">
              {{ (totalAborted ? totalAborted : 0) | indianNumber }}
            </span>
          </div>
          <div class="kpi-visual">
            <img
              src="../../assets/aborted.png"
              alt="Total Aborted Devices Image"
            />
          </div>
        </div>

        <!-- Total Completed Devices -->
        <div
          class="kpi-card kpi-gradient-green"
          (click)="changeKPISelected('Completed')"
          tabindex="0"
          (keydown.enter)="changeKPISelected('Completed')"
        >
          <div class="kpi-details">
            <span class="kpi-content"
              >Total Completed Devices
              <app-info-tooltip
                block
                heading="Total Completed Devices"
                [description]="kpiInfo.completed"
                (click)="$event.stopPropagation()"
              ></app-info-tooltip
            ></span>
            <span class="kpi-value">{{
              (totalCompleted ? totalCompleted : 0) | indianNumber
            }}</span>
          </div>
          <div class="kpi-visual">
            <img
              src="../../assets/completed-task.png"
              alt="Total Completed Devices Image"
            />
          </div>
        </div>
      </div>

      <div class="component-container" #tableContainer>
        <!-- Component Header Section -->
        <div class="component-header">
          <h6 class="component-title">
            {{ kpiSelected }} FOTA Batch Device List
          </h6>
          <div class="component-actions">
            <button
              class="primary-button"
              type="button"
              (click)="filterDropdownMenus()"
            >
              Filter<mat-icon class="btn-icon">filter_list</mat-icon>
            </button>
            <app-common-search
              [initialSearchValue]="searchField"
              matTooltip="UIN | IMEI"
              (searchSubmit)="onSearch($event)"
            ></app-common-search>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>UIN</th>
                <th>IMEI</th>
                <th>State</th>
                <th>AF</th>
                <th>UFW</th>
                <th>Last Login</th>
                <!-- <th>Added To Batch</th> -->
                <th>D/L%</th>
                <th>FOTA Status</th>
                <!-- <th>Download Duration</th> -->
                <th>1st SEO Status</th>
                <th>1st IP Status</th>
                <th>2nd IP Status</th>
                <th>2nd SEO Status</th>
                <th>3rd IP Status</th>
                <th>4th IP Status</th>
                <th>Updated At</th>
                <th>Action</th>
              </tr>
            </thead>
            @if (
              fotaBatchFotaDeviceDetails &&
              fotaBatchFotaDeviceDetails.length > 0
            ) {
              <tbody>
                @for (
                  fotaDeviceDetail of fotaBatchFotaDeviceDetails
                    | paginate
                      : {
                          id: 'paginate',
                          itemsPerPage: size,
                          currentPage: page,
                          totalItems: totalCount,
                        };
                  track fotaDeviceDetail
                ) {
                  <tr
                    [ngClass]="{
                      'red-row': fotaDeviceDetail.isAborted,
                      'green-row':
                        fotaDeviceDetail.deviceFotaCompletionStatus === true &&
                        fotaDeviceDetail.deviceFotaStatus === 'Completed' &&
                        fotaDeviceDetail.isAborted !== true,
                      'blue-row':
                        fotaDeviceDetail.deviceFotaCompletionStatus === true &&
                        fotaDeviceDetail.deviceFotaStatus === 'Skipped' &&
                        fotaDeviceDetail.isAborted !== true,
                    }"
                    [matTooltip]="
                      fotaDeviceDetail.isAborted
                        ? fotaDeviceDetail.abortReason || 'Aborted'
                        : ''
                    "
                  >
                    <td>
                      {{ fotaDeviceDetail.uin }}
                    </td>
                    <td>
                      {{ fotaDeviceDetail.imei }}
                    </td>
                    <td>
                      {{ fotaDeviceDetail.state }}
                    </td>
                    <td>
                      {{
                        fotaDeviceDetail.currentFirmwareVersion
                          ? fotaDeviceDetail.currentFirmwareVersion
                          : '--'
                      }}
                    </td>
                    <td>
                      {{ fotaDeviceDetail.targetFirmwareVersion }}
                    </td>
                    <td>
                      {{
                        fotaDeviceDetail.lastDevicePing
                          ? (fotaDeviceDetail.lastDevicePing
                            | date: 'dd-MMM-yyyy hh:mm:ss a')
                          : '--'
                      }}
                      <app-info-tooltip
                        block
                        heading="Login Ping Count"
                        [description]="getPingCountTooltip(fotaDeviceDetail)"
                      ></app-info-tooltip>
                    </td>
                    <!-- <td>
                      {{ fotaDeviceDetail.addedToBatch ? 'Yes' : 'No' }}
                    </td> -->
                    <td>
                      {{ fotaDeviceDetail.progress }} %
                      <app-info-tooltip
                        block
                        heading="Download Duration Breakup"
                        [description]="
                          downloadDurationTooltip(fotaDeviceDetail)
                        "
                      ></app-info-tooltip>
                    </td>
                    <td>
                      {{ fotaDeviceDetail.deviceFotaStatus }}
                      <app-info-tooltip
                        block
                        heading="FOTA Attempt Count"
                        [description]="getRetryCountTooltip(fotaDeviceDetail)"
                      ></app-info-tooltip>
                    </td>
                    <!-- <td>
                      {{
                        fotaDeviceDetail.startedAt
                          ? (fotaDeviceDetail.startedAt
                            | date: 'dd-MMM-yyyy hh:mm:ss a')
                          : '--'
                      }}
                      to
                      {{
                        fotaDeviceDetail.completedAt
                          ? (fotaDeviceDetail.completedAt
                            | date: 'dd-MMM-yyyy hh:mm:ss a')
                          : '--'
                      }}
                    </td> -->
                    <td>
                      {{ fotaDeviceDetail.stateEnableSetStatus || '--' }}
                      <app-info-tooltip
                        block
                        heading="1st SEO Details"
                        [description]="get1stSEOTooltip(fotaDeviceDetail)"
                      ></app-info-tooltip>
                    </td>
                    <td>
                      {{ fotaDeviceDetail.govtIp1SetStatus || '--' }}
                      <app-info-tooltip
                        block
                        heading="1st IP Details"
                        [description]="getGovtIp1Tooltip(fotaDeviceDetail)"
                      ></app-info-tooltip>
                    </td>
                    <td>
                      {{ fotaDeviceDetail.govtIp2SetStatus || '--' }}
                      <app-info-tooltip
                        block
                        heading="2nd IP Details"
                        [description]="getGovtIp2Tooltip(fotaDeviceDetail)"
                      ></app-info-tooltip>
                    </td>
                    <td>
                      {{
                        fotaDeviceDetail.secondaryStateEnableSetStatus || '--'
                      }}
                      <app-info-tooltip
                        block
                        heading="2nd SEO Details"
                        [description]="
                          get2ndSEOTooltip(fotaDeviceDetail)
                        "
                      ></app-info-tooltip>
                    </td>
                    <td>
                      {{ fotaDeviceDetail.govtIp3SetStatus || '--' }}
                      <app-info-tooltip
                        block
                        heading="3rd IP Details"
                        [description]="getGovtIp3Tooltip(fotaDeviceDetail)"
                      ></app-info-tooltip>
                    </td>
                    <td>
                      {{ fotaDeviceDetail.govtIp4SetStatus || '--' }}
                      <app-info-tooltip
                        block
                        heading="4th IP Details"
                        [description]="getGovtIp4Tooltip(fotaDeviceDetail)"
                      ></app-info-tooltip>
                    </td>
                    <td>
                      {{
                        fotaDeviceDetail.updatedAt
                          ? (fotaDeviceDetail.updatedAt
                            | date: 'dd-MMM-yyyy hh:mm:ss a')
                          : '--'
                      }}
                    </td>
                    <td>
                      <div class="action-buttons">
                        <button
                          class="primary-button abort-button"
                          type="button"
                          [disabled]="
                            fotaDeviceDetail.deviceFotaCompletionStatus !==
                              false ||
                            !deleteFota ||
                            fotaDeviceDetail.isAborted !== false
                          "
                          (click)="abort(fotaDeviceDetail._id)"
                        >
                          <mat-icon class="btn-icon">block</mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (
              fotaBatchFotaDeviceDetails &&
              fotaBatchFotaDeviceDetails.length === 0
            ) {
              <tbody>
                <tr>
                  <td colspan="16">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="dataNotFound"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <!-- Component Footer Section -->
        <div class="component-footer">
          @if (
            fotaBatchFotaDeviceDetails && fotaBatchFotaDeviceDetails.length > 0
          ) {
            <app-common-component-pagination
              [totalItems]="totalCount"
              [pageSize]="size"
              [currentPage]="page"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
          @if (
            fotaBatchDetails &&
            fotaBatchDetails.status === 'Not-Started' &&
            fotaBatchFotaDeviceDetails &&
            fotaBatchFotaDeviceDetails.length > 0 &&
            updateFota
          ) {
            <div class="component-separator"></div>
            <div class="button-group">
              <button
                class="submit-button"
                type="button"
                id="startFotaButton"
                (click)="startFota()"
              >
                Start FOTA
              </button>
            </div>
          }
        </div>
      </div>
    }
  </form>
  @if (filter === true) {
    <div class="custom-container">
      <!-- Filter Modal -->
      <div class="custom-modal custom-modal-s" id="filterDetails">
        <div class="custom-modal-dialog">
          <div class="custom-modal-content">
            <!-- Modal Header -->
            <div class="custom-modal-header">
              <h4 class="custom-modal-title">Filter</h4>
              <button
                type="button"
                class="custom-close-btn"
                (click)="closeModal()"
              >
                &times;
              </button>
            </div>
            <form [formGroup]="deviceFotaFilterForm" novalidate>
              <div class="custom-modal-body">
                <div class="component-container">
                  <div class="component-body">
                    <div class="form-section">
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>State Filter</mat-label>
                          <mat-select formControlName="state">
                            <mat-option value="">All</mat-option>
                            @for (item of fotaBatchDetails.states; track item) {
                              <mat-option [value]="item">
                                {{ item }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Firmware Version Filter</mat-label>
                          <mat-select formControlName="version">
                            <mat-option value="">All</mat-option>
                            @for (
                              item of fotaBatchDetails.firmwareVersions;
                              track item
                            ) {
                              <mat-option [value]="item">
                                {{ item }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <!-- Separator between Body and Footer -->
                  <div class="component-separator"></div>

                  <div class="component-footer">
                    <div class="button-group">
                      <button
                        type="button"
                        class="submit-button"
                        (click)="onFilterChange()"
                      >
                        Submit
                        <mat-icon class="btn-icon">check_circle</mat-icon>
                      </button>

                      <button
                        type="button"
                        class="clear-button"
                        (click)="clearFilter()"
                      >
                        Clear <mat-icon class="btn-icon">clear</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  }
</div>
